<script setup>
import { useStoreGetters, useStore } from 'dashboard/composables/store';
import { computed, onMounted } from 'vue';
import { useBranding } from 'shared/composables/useBranding';
import IntegrationItem from './IntegrationItem.vue';
import PageLayout from 'dashboard/components-next/layout/PageLayout.vue';
import PageHeader from 'dashboard/components-next/layout/PageHeader.vue';

const store = useStore();
const getters = useStoreGetters();
const { replaceInstallationName } = useBranding();

const uiFlags = getters['integrations/getUIFlags'];

const integrationList = computed(
  () => getters['integrations/getAppIntegrations'].value
);

onMounted(() => {
  store.dispatch('integrations/get');
});
</script>

<template>
  <PageLayout>
    <template #header>
      <PageHeader
        icon="i-lucide-plug"
        accent="blue"
        :title="$t('INTEGRATION_SETTINGS.HEADER')"
        :subtitle="
          replaceInstallationName($t('INTEGRATION_SETTINGS.DESCRIPTION'))
        "
      />
    </template>
    <woot-loading-state
      v-if="uiFlags.isFetching"
      :message="$t('INTEGRATION_SETTINGS.LOADING')"
    />
    <div v-else class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
      <IntegrationItem
        v-for="item in integrationList"
        :id="item.id"
        :key="item.id"
        :logo="item.logo"
        :name="item.name"
        :description="item.description"
        :enabled="item.enabled"
      />
    </div>
  </PageLayout>
</template>
